import React, { useState } from "react"

import PropTypes from "prop-types"

import "./index.less"
import { DotIcon } from "../../../icons/svg/iconDot"
import { truncateText } from "../../../utils/functions"
/*
const data = [
  {
    name: "Paquete de bienvenida",
    pv: 95,
    value: 900,
  },
  {
    name: "Política de vacaciones",
    pv: 90,
    value: 900,
  },
  {
    name: "Equipo",
    pv: 80,
    value: 9000,
  },
  {
    name: "Instalaciones de trabajo",
    pv: 95,
    value: 900,
  },
  {
    name: "Herramientas de trabajo",
    pv: 70,
    value: 900,
  },
  {
    name:
      "Equipo Equipo Equipo Equipo Equipo Equipo Equipo Equipo EquipoEquipo Equipo Equipo Equipo Equipo Equipo Equipo Equipo EquipoEquipo Equipo Equipo Equipo Equipo Equipo Equipo Equipo EquipoEquipo Equipo Equipo aaaaaaaaa",
    pv: 90,
    value: 800,
  },
  {
    name: "Herramientas de trabajo",
    pv: 70,
    value: 900,
  },
]
let dataResult = []
data.map((row) => {
  dataResult.push({
    name: row.name,
    pv: row.pv,
    name_sort: truncateText(row.name, 19),
    name_sort_legend: truncateText(row.name, 19),
    value: row.value,
    value_text: `${row.pv}%`,
  })
}) */

const COLORS = [
  "#2694FC",
  "#F6B673",
  "#55C8AE",
  "#E37879",
  "#E197D1",
  "#56CCF2",
  "#727DE2",
  "#C0D77E",
  "#EF9771",
  "#B173C7",
]

export function LegendPieChart(props) {
  const [activeIndex, setActiveIndex] = useState(null)
  let dataResult = []
  if (props.data) {
    props.data.map((row) => {
      dataResult.push({
        name: row.answer_option_name,
        pv: Number(row.value),
        name_sort: truncateText(row.answer_option_name, 19),
        name_sort_legend: truncateText(row.answer_option_name, 19),
        value: Number(row.employees),
        value_text: row.value_text,
      })
    })
  }

  const renderOptions = () => {
    return dataResult.map((row, index) => {
      return (
        <div className="legendItem">
          <DotIcon style={{ color: COLORS[index % COLORS.length] }} />
          <div className="labelLegend" style={{ color: "#4F4F4F" }}>
            {`${row.name_sort}`} <strong>{row.value_text}</strong>
          </div>
        </div>
      )
    })
  }
  const styleCustom =
    dataResult.length > 10 ? { justifyContent: "start" } : null
  return (
    <div className="LegendPieChart" style={styleCustom}>
      {renderOptions()}
    </div>
  )
}

LegendPieChart.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  measureGeneral: PropTypes.object,
  getDataChildren: PropTypes.func,
  getBackData: PropTypes.func,
  dimensionParent: PropTypes.number,
  isAmbassador: PropTypes.bool,
  showDimensionBenchmark: PropTypes.bool,
  hideImpact: PropTypes.bool,
}
export default LegendPieChart
